// Header.tsx
import React, { useState } from "react";
import { Menu, X, Mail } from "lucide-react";
import { Link, useLocation, useParams } from "react-router-dom";
import WhatsAppLogo from "@/assets/whatsapp.png";

const WHATSAPP_CLAIM_URL =
    "https://wa.me/919324095283?text=Hi%2C%20I%20want%20to%20raise%20a%20request";

const Header: React.FC = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const toggleMobile = () => setMobileOpen((s) => !s);
    const location = useLocation()
    console.log(location.pathname);
    return (
        <>
            <header data-aos="fade-down" className="tw-bg-black tw-px-6 md:tw-px-16 tw-justify-between tw-shadow-sm tw-shadow-[#00c5fb91] tw-flex tw-items-center tw-h-[84px] tw-max-h-[84px] tw-overflow-hidden tw-box-border">
                <div className="tw-flex tw-items-center tw-gap-4">
                    <button
                        className="tw-inline-flex md:tw-hidden tw-items-center tw-justify-center tw-p-2 tw-rounded-md tw-text-white focus:tw-outline-none"
                        aria-label="Open menu"
                        onClick={toggleMobile}
                    >
                        <Menu />
                    </button>
                    <Link to={'/'}>
                        <img src="/desktopLogo.png" alt="logo" className="tw-h-10 md:tw-h-15 tw-w-auto" />
                    </Link>
                </div>

                <a
                    href={WHATSAPP_CLAIM_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-w-auto tw-h-[50px] tw-max-h-full tw-shrink-0 tw-box-border tw-leading-none tw-rounded-[10px] tw-bg-[#00C5FB]/10 tw-text-white tw-font-medium tw-no-underline hover:tw-bg-[#00C5FB]/20 tw-transition-colors"
                >
                    <img src={WhatsAppLogo} alt="WhatsApp" width={24} height={24} className="tw-h-6 tw-w-6 tw-shrink-0 tw-object-contain" />
                    <p className="tw-text-sm tw-font-medium tw-hidden sm:tw-block"> Quick Claim</p>
                </a>
            </header>

            {/* Mobile Sidebar */}
            {mobileOpen && (
                <div
                    className="tw-fixed tw-inset-0 tw-z-40 tw-flex"
                    role="dialog"
                    aria-modal="true"
                >
                    <div className="tw-fixed tw-inset-0 tw-bg-black tw-bg-opacity-50" onClick={toggleMobile} />
                    <aside className={`tw-relative tw-w-64 tw-max-w-full tw-bg-black tw-h-full tw-shadow-lg tw-transform tw-transition-transform tw-duration-300 ${mobileOpen ? "tw-translate-x-0" : "-tw-translate-x-full"}`}>
                        <div className="tw-p-4 tw-flex tw-justify-between tw-items-center">
                            <img src="/logo.png" alt="logo" className="tw-h-4 md:tw-h-10" />
                            <button aria-label="Close menu" onClick={toggleMobile} className="tw-p-2">
                                <X />
                            </button>
                        </div>
                        <nav className="tw-px-4 tw-flex tw-flex-col tw-gap-4">
                            <Link to={''} onClick={toggleMobile} className="tw-py-2 tw-border-b">Home</Link>
                            <Link to={'/schedule-demo'} onClick={toggleMobile} className="tw-py-2 tw-border-b">Schedule a Demo</Link>
                            <Link to={'/customer-login'} onClick={toggleMobile} className="tw-py-2 tw-border tw-text-center tw-rounded">Log in</Link>
                        </nav>
                    </aside>
                </div>
            )}
        </>
    );
};

export default Header;
